<template>
  <div class="mobile-container" ref="mobileContainer">
    <vueper-slides
      :fixed-height="true"
      :arrows="false"
      :bullets="false"
      slide
      @before-slide="on_before_slide($event)"
      @slide="on_after_slide($event)"
      ref="mobile_slider"
    >
      <vueper-slide
        v-for="(n, i) in (sectionCount+1)"
        :key="i"
        :content="slide_src(i)"
      />
    </vueper-slides>

    <transition name="fade" mode="out-in">
      <AppSidebar />
    </transition>
  </div>
</template>
<script>
import AppSidebar from "./AppSidebar";
import { VueperSlides, VueperSlide } from "vueperslides";
import { mapGetters } from "vuex";
export default {
  name: "MobileContainer",
  components: {
    AppSidebar,
    VueperSlides,
    VueperSlide
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["sectionCount"])
  },
  methods: {
    slide_src(qid) {
      return (
        '<img class="slide-image slide-image-' +
        qid +
        '" src="static/img/_0.png" style="background-image:url(static/content/mobile/' +
        qid +
        '.jpg)">'
      );
    },
    on_before_slide(ev) {},
    on_after_slide(ev) {
      setTimeout(
        function () {
          var currentSection = ev.currentSlide.index;
          console.log(currentSection);
          window.getStr("on_section_anim_ended", currentSection + "");
        }.bind(this),
        800
      );
    },
    on_mobile_send_msg(msg, param) {
      console.log("mobile got message", msg, param, param * 1 < 7);
      switch (msg) {
        case "JsRequestSection":
          if (param != "" && "undefined" != typeof param) {
            window.getStr("on_section_anim_started", param);
            if (param * 1 <= this.sectionCount) {
              this.$refs.mobile_slider.goToSlide(param * 1);
            } else {
              this.$refs.mobile_slider.goToSlide(0);
            }
          }
          break;
      }
    },
    do_resize() {
      this.$bus.$emit("on-request-booth-resize", this.$refs.mobileContainer);
    },
    fix_dimensions() {
      this.do_resize();
      window.addEventListener(
        "resize",
        function () {
          this.do_resize();
        }.bind(this)
      );
    }
  },
  mounted() {
    this.$bus.$on("on-mobile-send-msg", this.on_mobile_send_msg);
    this.fix_dimensions();
    this.$ga.page("/mobile-booth");
  }
};
</script>
<style>
.mobile-container img {
  width: 100%;
  height: 100%;
}
.mobile-container {
}
.mobile-container .vueperslides {
  width: 100vw;
  color: #f0f0f0;
}
.mobile-container .vueperslides--fixed-height {
  xheight: calc(var(--vh, 1vh) * 100);
  height: 100%;
}
.mobile-container .vueperslide__content {
  height: 100%;
  width: 100%;
}
.mobile-container .app_sidebar {
  z-index: 10;
}
.slide-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileContainer.vue